import React, { Component } from 'react'
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { CompanyMasterPopup } from './CompanyMasterTable';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import CommonServices from '../../../services/axiosServices/apiServices/CommonServices';
import { saveAs } from "file-saver";
import { permission } from '../../../utils/enums/ValidationMessage';

export default class CompanyMaster extends Component {
  constructor(props) {
    super(props)
    this.accountTransactionServices = new AccountTransactionServices();
    this.masterEntryServices = new MasterEntryServices();
    this.SwalServices = new SwalServices();
    this.commonServices = new CommonServices();
    this.state = {
      permissions: {
        //isView: false,
        isAddEdit: false,
        isDelete: false,
        isView: false,
      },
      isModalOpen: false,
      rowData: [],
      colDefs: [],
      paginationPageSize: 50,
      rowHeight: 40,
      idCompany: 0,
      idUser: 0,
      networkConfiguration: [],
      companyObject: {
        companyName: '',
        office_Address: '',
        cityName: '',
        stateCode: '',
        pincode: '',
        contactNo: '',
        otpMobNo: '',
        phoneNo: '',
        comp_EmailID: '',
        faxNo: '',
        website: '',
        panNo: '',
        gstNo: '',
        gstDate: '',
        // selectLogo: '',
        // selectSign: '',
        // selectHeader: '',
        selectDate: '',
        logoFileName: "",
        signFileName: "",
        headerImage: "",
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRules: {
        companyName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "company name"
            ),
          },
        ],
        office_Address: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "office address"
            ),
          },
        ],
        // cityName: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "city name"
        //     ),
        //   },
        // ],
        // stateCode: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "state code"
        //     ),
        //   },
        // ],
        // pincode: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "pincode"
        //     ),
        //   },
        // ],
        contactNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "contact no"
            ),
          },
        ],
        // otpMobNo: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "otp mobile no"
        //     ),
        //   },
        // ],
        // comp_EmailID: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "email id"
        //     ),
        //   },
        // ],
        // panNo: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "PAN no"
        //     ),
        //   },
        // ],
        // gstNo: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "GST no"
        //     ),
        //   },
        // ],
        // gstDate: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "GST date"
        //     ),
        //   },
        // ],
      },
    }
  }

  openPopUpForAddingItem = () => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.add);
      return;
    }
    this.setState({ isModalOpen: true }, () => {
      this.getMasterCompanySelectbyID();
    })
  };

  onRowDoubleClicked = (event) => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.edit);
      return;
    }
    this.setState({ isModalOpen: true }, () => {
      this.getMasterCompanySelectbyID();
    })
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.companyObject,
      this.state.validationRules,
      this.state.validState,
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  }

  setOpenModel = () => {
    this.resetDetails();
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };
  closePopup = () => {
    this.resetDetails();
    this.setState({ isModalOpen: false, });
  };

  handleChange = (event, name) => {
    //debugger
    let value = event.target.value;
    let details = this.state.companyObject;
    details[name] = value;
    this.setState({ companyObject: details });
  }

  componentDidMount = () => {
    let prop = getAuthProps()
    //debugger
    if (prop.idCompany && prop.idCompany > 0) {
      this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
        this.procSelectAllRecordsSP();
        //this.usp_Master_GeneralProductSelect();
      });
    } setTimeout(() => {
      //this.removeDefaultBorders();
    }, 100);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
  };

  procSelectAllRecordsSP = () => {
    let request = {
      formname: "Company Master",
      idCompany: this.state.idCompany,
      allowToRateVisible: 1,
      idUser: 0,
    };
    this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let permissions = response.responseItem.responseContent[0][0];
        if (permissions.view) {
          let data = response.responseItem.responseContent[1];
          if (data.length > 0) {
            const dynamicColDefs = Object.keys(data[0]).map((key) => ({
              field: key,
              headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
              flex: 1,
              filter: true,
              floatingFilter: true,
              minWidth: this.getColumnWidth(key),
              //pinned: ["voucherNo", "voucherDate", "accSubHead",].includes(key) ? true : false,
              //width: this.getPinnedWidth(key),
              hide: ["idCompany", "sR.No"].includes(key) ? true : false,
              // valueFormatter: key.includes("voucherDate") ? (params) => {
              //   if (!params.value) return "";
              //   const date = new Date(params.value);
              //   return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
              // } : undefined,
            }));
            //var colName = dynamicColDefs[0].field;
            //let id = data ? data[0][colName] : 0;
            this.setState({
              rowData: data,
              colDefs: dynamicColDefs,
              //caption: "Journal Voucher",
              //colName: colName
            }, () => {
              //this.procSelectAllRecord2GridviewSP(id, "Journal Voucher");
              this.getNetworkConfiguration();
              this.setPermissions(permissions);
            }, () => {
              if (this.gridApi) {
                //this.gridApi.hideOverlay();
              }
            });
          } else {
            this.setPermissions(permissions);
            if (this.gridApi) {
              //this.gridApi.showNoRowsOverlay();
            }
          }
        } else {
          window.location.href = "/authentication/UnAuthorized";
        }
      }
    });
  }

  setPermissions = (permissions) => {
    let data = this.state.permissions;
    data.isAddEdit = permissions.addEdit;
    data.isDelete = permissions.delete;
    data.isView = permissions.view;
    this.setState({ permissions: data });
  }

  getColumnWidth = (key) => {
    const columnWidths = {
      "companyName": window.innerWidth * 0.3,
      "office_Address": window.innerWidth * 0.3,
      "contactNo": window.innerWidth * 0.06,
    };
    return columnWidths[key];
  };

  getNetworkConfiguration = () => {
    this.accountTransactionServices.getNetworkConfiguration().then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let data = response.responseItem.responseContent;
        this.setState({ networkConfiguration: data }, () => {
          //this.getPartyAccountGeneral();
        })
      }
    });
    //this.getPartyAccountGeneral();
  }

  getMasterCompanySelectbyID = () => {
    this.masterEntryServices.getMasterCompanySelectbyID(this.state.idCompany).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let res = response.responseItem.responseContent[0];
        //debugger;
        let data = { ...res }; //this.state.companyObject;
        //data.companyName = res. ,
        //data.address = res.office_Address;
        // data.cityName = res. ;
        // data.stateCode = res. ;
        // data.pincode = res. ;
        //data.contactNo = res.contactNo;
        //data.otpMobNo = res.otpMobNo;
        //data.phoneNo = res.phoneNo;
        //data.email = res.comp_EmailID;
        // data.faxNo = res. ;
        // data.website = res. ;
        // data.panNo = res. ;
        // data.gstNo = res. ;
        data.gstDate = moment(res.gstDate).format('YYYY-MM-DD');
        // data.selectLogo = res. ;
        // data.selectSign = res. ;
        //data.selectHeader = res. ;
        //data.selectDate = res. ;
        this.setState({ companyObject: data }, () => {
          //this.calculatePricing()
        });
      }
    });
  }

  usp_Master_ItemStockTransferNewYear = () => {
    this.SwalServices
      .Confirm("Item stock transfer", "Are you sure ?", "Okay", "Cancel")
      .then((response) => {
        if (response) {
          this.masterEntryServices.usp_Master_ItemStockTransferNewYear(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
              this.SwalServices.Success("Successfully Transfer.");
            }
            else {
              this.SwalServices.Error(response.message);
            }
          });
        }
      });
  }

  usp_Master_PartyBalanceTransferNewYear = () => {
    if (this.state.companyObject.selectDate) {
      let request = {
        idCompany: this.state.idCompany,
        fromDate: this.state.companyObject.selectDate,
      };
      this.SwalServices
        .Confirm("Party balance transfer", "Are you sure ?", "Okay", "Cancel")
        .then((response) => {
          if (response) {
            this.masterEntryServices.usp_Master_PartyBalanceTransferNewYear(request).then((response) => {
              if (response.statusCode === 200 && response.responseItem !== null) {
                this.SwalServices.Success("Successfully Transfer.");
              } else {
                this.SwalServices.Error(response.message);
              }
            });
          }
        });
    } else {
      this.SwalServices.Error("Please select 'Select date'.");
    }
  }

  usp_Master_BankClosingTransferNewYear = () => {

    if (this.state.companyObject.selectDate) {
      let request = {
        idCompany: this.state.idCompany,
        fromDate: this.state.companyObject.selectDate,
      };
      this.SwalServices
        .Confirm("Bank closing transfer", "Are you sure ?", "Okay", "Cancel")
        .then((response) => {
          if (response) {
            this.masterEntryServices.usp_Master_BankClosingTransferNewYear(request).then((response) => {
              if (response.statusCode === 200 && response.responseItem !== null) {
                this.SwalServices.Success("Successfully Transfer.");
              } else {
                this.SwalServices.Error(response.message);
              }
            });
          }
        });
    } else {
      this.SwalServices.Error("Please select 'Select date'.");
    }
  }

  usp_TruncateAllRecords = () => {
    this.SwalServices
      .Confirm("Start new year", "Are you sure ?", "Okay", "Cancel")
      .then((response) => {
        if (response) {
          this.masterEntryServices.usp_TruncateAllRecords().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
              // let data = response.responseItem.responseContent;
              // this.setState({ networkConfiguration: data }, () => {
              this.SwalServices.Success("Successfully Transfer.");
              //})
            } else {
              this.SwalServices.Error(response.message);
            }
          });
        }
      });
  }

  submit = () => {
    const isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      //let data = this.state.ledgerDetails;
      let requestData = { ...this.state.companyObject };
      this.masterEntryServices.usp_Master_CompanyUpdate(requestData).then((response) => {
        //debugger
        if (response.statusCode === 200 && response.responseItem !== null) {
          let dynamicData = response.responseItem.responseContent;
          if (dynamicData !== null) {
            //if (this.state.companyObject.updateStatus === 1) {
            this.SwalServices.Success("Updated sucessfully.");
            // } else {
            //   this.SwalServices.Success("Save sucessfully.");
            // }
            this.setState({
              isModalOpen: false,
            }, () => {
              this.procSelectAllRecordsSP();
              this.resetDetails();
            });
          } else {
            this.procSelectAllRecordsSP();
          }
        } else {
          this.SwalServices.Error(response.message);
        }
      });
    }
  }

  resetDetails = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let object = this.state.companyObject;
    object.companyName = '';
    object.office_Address = '';
    object.cityName = '';
    object.stateCode = '';
    object.pincode = '';
    object.contactNo = '';
    object.otpMobNo = '';
    object.phoneNo = '';
    object.comp_EmailID = '';
    object.faxNo = '';
    object.website = '';
    object.panNo = '';
    object.gstNo = '';
    object.gstDate = '';
    object.selectLogo = '';
    object.selectSign = '';
    object.selectHeader = '';
    object.selectDate = '';
    this.setState({ companyObject: object, validState: validState });
  }

  onFileChange = (event, identity) => {
    //debugger
    const file = event.target.files[0];
    // if (identity === "Upload_Certificate") {
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "application/pdf" ||
        file.type === "application/pdf" ||
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/msword" ||
        file.type === "application/msexcel" ||
        file.type === "application/vnd.ms-excel")
    ) {
      let uploadFile = { ...this.state.resFile };
      uploadFile.filename = file.name;
      uploadFile["file"] = file;
      uploadFile.storagePath = identity;
      let detail = { ...this.state.partnerConsultantDetails };
      detail.brochureFilePath = file.name;
      // this.setState({ partnerConsultantDetails: detail },
      //   () => this.validateField("brochureFilePath")
      // );
      this.commonServices.uploadPDF(uploadFile).then((response) => {
        if (response != null) {
          let detail = this.state.companyObject;
          if (identity === 'Logo') {
            detail.logoFileName = response.fileName;
          } else if (identity === 'Sign') {
            detail.signFileName = response.fileName;
          } else if (identity === 'Header') {
            detail.headerImage = response.fileName;
          }
          this.setState({ companyObject: detail });
          this.SwalServices.Success("Uploaded");
        }
        else {
          this.SwalServices.Error(response.message);
        }
      })
    }
    else {
      this.SwalServices.Error("Please select only Image!");
    }
    // }      
  };

  getFiles = (type, Filepath) => {
    if (Filepath) {
      let request = [
        // this.state.SLOTSApplicationDetails.slotsMemberId,
        type,
        Filepath,
      ];
      this.commonServices.getFiles(request).then((response) => {
        if (response.data !== null && response.status === 200) {
          var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
          var filename = "";
          filename = `${type}${formattedDate}`;
          const extension = Filepath.split(".").pop();
          if (extension) {
            saveAs(new Blob([response.data]), `${filename}.${extension}`);
          }
        } else {
          this.SwalServices.Error(response.message);
        }
      });
    } else {
      this.SwalServices.Error("No data found");
    }
  };

  render() {
    return (
      <div className='company-master'>
        <div className='data-display'>
          <div className='data-display-inner relative'>
            <ButtonGrp buttons={['add', 'print', 'delete']}
              onClickHandlers={{
                add: () => this.openPopUpForAddingItem(),
                // update: () => this.openPopUpForUpdateItem(),
                print: this.handlePrint,
                delete: this.handleDelete,
              }}
            />
            <CompanyMasterPopup
              isModalOpen={this.state.isModalOpen}
              setOpenModel={this.setOpenModel.bind(this)}
              companyObject={this.state.companyObject}
              handleChange={this.handleChange.bind(this)}
              validState={this.state.validState}
              close={this.closePopup.bind(this)}
              submit={this.submit.bind(this)}
              usp_Master_ItemStockTransferNewYear={this.usp_Master_ItemStockTransferNewYear.bind(this)}
              usp_Master_PartyBalanceTransferNewYear={this.usp_Master_PartyBalanceTransferNewYear.bind(this)}
              usp_Master_BankClosingTransferNewYear={this.usp_Master_BankClosingTransferNewYear.bind(this)}
              usp_TruncateAllRecords={this.usp_TruncateAllRecords.bind(this)}
              onFileChange={this.onFileChange.bind(this)}
              getFiles={this.getFiles.bind(this)}
            />
            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                <div className="table-inner">
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Company master</h1>
                </div>
                <AgGridReact
                  rowData={this.state.rowData}
                  rowHeight={this.state.rowHeight}
                  columnDefs={this.state.colDefs}
                  pagination={true}
                  paginationPageSize={this.state.paginationPageSize}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  onGridReady={this.onGridReady}
                  overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                  overlayNoRowsTemplate="<span style='padding: 10px; border: 1px solid #444; background: lightgray;'>No rows to show</span>"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
